function countDecimals(value: number): number {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0; 
}

function roundToNDecimals(value: number, nDecimals: number): number {
  return Math.round(value * Math.pow(10, nDecimals)) / Math.pow(10, nDecimals);
}

function roundToStep(value: number, step: number): number { 
  const roundedToStep = Math.round(value / step) * step;
  const decimalsInStep = countDecimals(step);
  return roundToNDecimals(roundedToStep, decimalsInStep + 1);
}

export {roundToStep};